import React from "react";
import { GoArrowLeft } from "react-icons/go";
import { Link } from "react-router-dom";

const OutPatientOverview = () => {
  const patient = {
    patientId: "OP-00024567",
    name: "Sundari Krishnan",
    age: 58,
    gender: "Female",
    contact: "+91 98765 43210",
    email: "sundari.krishnan@example.com",
    address: "32, MG Street, Chennai, Tamil Nadu - 600001",
    registrationDate: "28-Jul-2025",
    appointmentDate: "8-Jul-2024",
    appointmentTime: "10:45 AM",
    doctor: "Dr. Arjun Mehta",
    department: "Cardiology",
    visitReason: "Follow-up for Hypertension",
    medicalHistory: [
      "Type II Diabetes (Diagnosed 2018)",
      "High Blood Pressure (Diagnosed 2019)",
      "Mild Osteoarthritis",
    ],
    diagnosis: "Stage 2 Hypertension with uncontrolled sugar",
    prescriptions: [
      "Telmisartan 40mg - Once Daily",
      "Metformin 500mg - Twice Daily",
      "Atorvastatin 10mg - Once at night",
    ],
    reports: [
      { name: "Blood Sugar Report", date: "2-Apr-2025", status: "Reviewed" },
      { name: "ECG", date: "12-Jun-2025", status: "Reviewed" },
      { name: "BP Monitoring Chart", date: "18-Jul-2025", status: "Pending" },
    ],
    treatmentPlan:
      "Monitor BP daily for 2 weeks, adjust dose based on readings. Schedule for 2D Echo next visit.",
    billing: {
      consultation: "₹600",
      tests: "₹1200",
      total: "₹1800",
      status: "Paid",
    },
    dischargeSummary:
      "Patient discharged post-consultation with stable vitals. Advised rest and follow-up in 30 days.",
  };

  return (
    <div style={{ maxWidth: "1000px", }}>
      {/* HEADER with Back Button */}
      <div
        className="header d-flex align-items-center mb-4"
        style={{ display: "flex", alignItems: "center", }}
      >
        <div
          className="flex items-center gap-4 flex-wrap"
          style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}
        >
          <Link to="/OpCaseSheet">
            <button
              style={{
                background: "#fff",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "500",
                border: "1px solid #ccc",
                height: "40px",
                width: "40px",
                cursor: "pointer",
              }}
            >
              <GoArrowLeft />
              <span className="sr-only">Back</span>
            </button>
          </Link>
          <div>
            <h1
              style={{
                fontSize: "28px",
                fontWeight: "bold",
                marginBottom: "6px",
                letterSpacing: "-0.5px",
              }}
            >
              Outpatient Overview
            </h1>
            <p style={{ color: "#6c757d", margin: 0 }}>
              View outpatient details.
            </p>
          </div>
        </div>
      </div>

      <div
        style={{
          borderBottom: "1px dashed gray",
          paddingBottom: "1rem",
          marginBottom: "2rem",
          display: "flex",
          justifyContent: "space-between",
        }}
      ></div>

      {/* MAIN OUTPATIENT CARD */}
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "12px",
          padding: "25px",
        }}
      >
        <Section title="Patient Details">
          <Detail label="Patient ID" value={patient.patientId} />
          <Detail label="Name" value={patient.name} />
          <Detail label="Age / Gender" value={`${patient.age} / ${patient.gender}`} />
          <Detail label="Contact" value={patient.contact} />
          <Detail label="Email" value={patient.email} />
          <Detail label="Address" value={patient.address} />
          <Detail label="Registered On" value={patient.registrationDate} />
        </Section>

        <Section title="Appointment Info">
          <Detail label="Doctor" value={patient.doctor} />
          <Detail label="Department" value={patient.department} />
          <Detail label="Appointment Date" value={patient.appointmentDate} />
          <Detail label="Time" value={patient.appointmentTime} />
          <Detail label="Visit Reason" value={patient.visitReason} />
        </Section>

        <Section title="Medical History">
          <ul style={{ margin: 0, paddingLeft: "20px", color: "#444" }}>
            {patient.medicalHistory.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </Section>

        <Section title="Diagnosis">
          <p style={{ margin: 0 }}>{patient.diagnosis}</p>
        </Section>

        <Section title="Prescriptions">
          <ul style={{ margin: 0, paddingLeft: "20px", color: "#444" }}>
            {patient.prescriptions.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </Section>

        <Section title="Reports">
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
              fontSize: "14px",
              color: "#333",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#f8f9fa" }}>
                <th style={thStyle}>Report Name</th>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Status</th>
              </tr>
            </thead>
            <tbody>
              {patient.reports.map((report, idx) => (
                <tr key={idx}>
                  <td style={tdStyle}>{report.name}</td>
                  <td style={tdStyle}>{report.date}</td>
                  <td style={tdStyle}>{report.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Section>

        <Section title="Treatment Plan">
          <p style={{ margin: 0 }}>{patient.treatmentPlan}</p>
        </Section>

        <Section title="Billing Summary">
          <Detail label="Consultation Fee" value={patient.billing.consultation} />
          <Detail label="Tests & Reports" value={patient.billing.tests} />
          <Detail label="Total" value={patient.billing.total} />
          <Detail label="Payment Status" value={patient.billing.status} />
        </Section>

        <Section title="Discharge Summary">
          <p style={{ margin: 0 }}>{patient.dischargeSummary}</p>
        </Section>
      </div>
    </div>
  );
};

// Utilities
const Section = ({ title, children }) => (
  <div style={{ marginBottom: "30px" }}>
    <h3
      style={{
        fontSize: "18px",
        color: "#00c234",
        marginBottom: "12px",
        borderBottom: "1px solid #dee2e6",
        paddingBottom: "4px",
      }}
    >
      {title}
    </h3>
    {children}
  </div>
);

const Detail = ({ label, value }) => (
  <div style={{ marginBottom: "6px", fontSize: "15px", color: "#444" }}>
    <strong>{label}:</strong> {value}
  </div>
);

const thStyle = {
  textAlign: "left",
  padding: "10px",
  borderBottom: "1px solid #ccc",
  fontWeight: "600",
};

const tdStyle = {
  padding: "10px",
  borderBottom: "1px solid #eee",
};

export default OutPatientOverview;
